import { defaultTheme } from '@sleepstation/themes-public-site'
import { createTheme } from '@sleepstation/utils'

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

const infoCardThemePositive = createTheme(
  `InfoCardPositive`,
  defaultTheme.api,
  {
    colors: {
      backgroundPrimary: `green`,
      backgroundPrimaryStart: `green`,
      backgroundPrimaryEnd: `green`,
      title: `white`,
      bodyBackground: `greenPale`,
      highlight: `green`,
    },
  },
  defaultTheme
)

export default infoCardThemePositive
